import React from 'react'
import PropTypes from 'prop-types'
import { DateRangePicker, Selector } from '@components'

const OrderHistoryFilters = ({
    searchTerm,
    setSearchTerm,
    viewType,
    setViewType,
    categoryFilter,
    setCategoryFilter,
    categoryOptions,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isUpcomingEnabled,
}) => {
    return (
        <div className="history-filters">
            <div className="search-container">
                <div className="search-input-wrapper">
                    <i className="bx bx-search search-icon"></i>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search order ID, vendor or item"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            <div className="view-type-buttons">
                <button className={`filter-btn ${viewType === 'History' ? 'active' : ''}`} onClick={() => setViewType('History')}>
                    History
                </button>
                <button
                    className={`filter-btn ${viewType === 'Upcoming' ? 'active' : ''}`}
                    onClick={() => setViewType('Upcoming')}
                    disabled={!isUpcomingEnabled}
                    style={{ opacity: isUpcomingEnabled ? 1 : 0.5, cursor: isUpcomingEnabled ? 'pointer' : 'not-allowed' }}
                >
                    Upcoming
                </button>
            </div>
            {viewType === 'History' && (
                <div className="date-range-container">
                    <DateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        onStartDateChange={setStartDate}
                        onEndDateChange={setEndDate}
                    />
                </div>
            )}
            {viewType === 'History' && (
                <div className="category-dropdown">
                    <Selector
                        value={categoryFilter}
                        options={categoryOptions}
                        onChange={setCategoryFilter}
                        containerClassName="category-select"
                    />
                </div>
            )}
        </div>
    )
}

OrderHistoryFilters.propTypes = {
    searchTerm: PropTypes.string.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    viewType: PropTypes.oneOf(['History', 'Upcoming']).isRequired,
    setViewType: PropTypes.func.isRequired,
    categoryFilter: PropTypes.object.isRequired,
    setCategoryFilter: PropTypes.func.isRequired,
    categoryOptions: PropTypes.array.isRequired,
    startDate: PropTypes.string.isRequired,
    setStartDate: PropTypes.func.isRequired,
    endDate: PropTypes.string.isRequired,
    setEndDate: PropTypes.func.isRequired,
    isUpcomingEnabled: PropTypes.bool.isRequired,
}

export default OrderHistoryFilters
